var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('img',{attrs:{"src":require("@/assets/img/zhang/lingxing.png"),"alt":""}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }